import { Calendar } from '@mantine/dates';
import dayjs from 'dayjs';

import classes from './AvailabilityCalendar.module.css';
import { useDesktop } from '@/hooks';

type AvailabilityCalendarProps = {
  month: number;
  year: number;
  availableDates: Set<string>;
  onToggleDate: (date: string) => void;
  readOnly: boolean;
};

const AvailabilityCalendarGrid: React.FC<AvailabilityCalendarProps> = ({
  month,
  year,
  availableDates,
  onToggleDate,
  readOnly,
}) => {
  const isDesktop = useDesktop();
  const controlledDate = dayjs(`${year}-${month}`).toDate();

  return (
    <Calendar
      date={controlledDate}
      maxLevel="month"
      firstDayOfWeek={0}
      hideOutsideDates
      getDayProps={(dateString) => ({
        onClick: () => {
          if (!readOnly) {
            onToggleDate(dateString);
          }
        },
      })}
      styles={{
        day: {
          height: isDesktop ? '64px' : '44px',
          width: isDesktop ? '64px' : '44px',
        },
        calendarHeader: {
          display: 'none',
        },
      }}
      renderDay={(dateString) => {
        const dateObj = dayjs(dateString);
        const dayNumber = dateObj.date();
        const formatted = dateObj.format('YYYY-MM-DD');
        const isAvailable = availableDates.has(formatted);

        const cellClasses = [
          classes.dayCell,
          isAvailable ? classes.dayAvailable : classes.dayUnavailable,
          readOnly ? classes.dayReadOnly : '',
        ]
          .filter(Boolean)
          .join(' ');

        return <div className={cellClasses}>{dayNumber}</div>;
      }}
    />
  );
};

export default AvailabilityCalendarGrid;
